import React, { useImperativeHandle, useMemo, useRef, useState } from 'react';

import LazyComponent from './LazyComponent';
import { IComponent } from './type';

export interface IGhostProps {}
export type GhostRefs = {
  render: (config: IComponent) => void;
};

const Ghost = React.forwardRef<GhostRefs, IGhostProps>((_, ref) => {
  const ghostRef = useRef<IComponent[]>([]);
  const [currentRender, setCurrentRender] = useState(0);

  useImperativeHandle(
    ref,
    () => {
      return {
        render(config) {
          ghostRef.current = [...ghostRef.current, config];
          setCurrentRender(ghostRef.current.length);
        },
      };
    },
    [],
  );
  const virtual = useMemo(() => {
    return ghostRef.current.map((config, index) => (
      <LazyComponent key={`${config.code}__${index}`} config={config} />
    ));
  }, [currentRender]);
  const portalStyles: React.CSSProperties = useMemo(() => {
    return {
      position: 'fixed',
      zIndex: 100,
    };
  }, []);
  return <div style={portalStyles}>{virtual}</div>;
});

export default Ghost;
